export function centsToPriceString(totalCents: number): string {
    const euros = Math.floor(totalCents / 100);
    const cents = totalCents % 100;

    return `${euros.toLocaleString('de-DE')},${cents.toLocaleString('de-DE', {
        minimumIntegerDigits: 2,
    })} €`;
}
